module.exports = __webpack_public_path__ + "static/previewPopOver-2b555363780349ae10fb568c461b3545.png";